import { render } from "./NcrmOnboardingOwnerField.vue?vue&type=template&id=cf017510&scoped=true"
import script from "./NcrmOnboardingOwnerField.vue?vue&type=script&lang=js"
export * from "./NcrmOnboardingOwnerField.vue?vue&type=script&lang=js"

import "./NcrmOnboardingOwnerField.vue?vue&type=style&index=0&id=cf017510&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf017510"]])

export default __exports__